import React from "react";
import TableCell from "../TableCell";
import DetailRow from "../DetailRow";
import RefDataLabel from "../Components/RefDataLabel";
import ProtectionSpecification from "./ProtectionSpecification";

const PPEInstructionsStructured = ({ data, idField, editFlag,serialNumber }) => {
  if (!data) return null;

  const renderProtectionSection = (title, protectionData, fieldName) => {
    if (!protectionData || protectionData.length === 0) return null;

    return (
      <>
        <div className="fw-bold mt-3 mb-2">{title}</div>

        {protectionData.map((each, index) => (
          <ProtectionSpecification
            key={index}
            data={each}
            editFlag={editFlag}
            idField={`${idField}.${fieldName}[${index}]`}
          />
        ))}
      </>
    );
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ width: "1%" }}>S.No</th>
            <th style={{ width: "30%" }}>Label</th>
            <th>Additional Fields</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td style={{ verticalAlign: "top" }}>
                {serialNumber}
              </td>
            {/* LEFT COLUMN - Internal Label */}
            <td style={{ verticalAlign: "top" }}>
              <TableCell
                enableEdit={true}
                editFlag={editFlag}
                data={data.internalLabel}
                idField={`${idField}.internalLabel["@none"]`}
              />
            </td>

            {/* RIGHT COLUMN */}
            <td style={{ verticalAlign: "top" }}>
              {data.personRole && (
                <DetailRow
                  label="Person Role"
                  data={data.personRole}
                  idField={`${idField}.personRole`}
                />
              )}

              {data.workPhase && data.workPhase.length > 0 && (
                <>
                  <div className="fw-bold">
                    <RefDataLabel
                      label="Work Phase"
                      isRefData={true}
                    />
                    :
                  </div>

                  <ul className="mb-2">
                    {data.workPhase.map((each, i) => (
                      <li key={i}>
                        <TableCell
                          data={each.label}
                          idField={`${idField}.workPhase[${i}].label["@none"]`}
                        />
                      </li>
                    ))}
                  </ul>
                </>
              )}

              {data.applicationEquipment &&
                data.applicationEquipment.length > 0 && (
                  <>
                    <div className="fw-bold">
                      <RefDataLabel
                        label="Application Equipment"
                        isRefData={true}
                      />
                      :
                    </div>

                    <ul className="mb-2">
                      {data.applicationEquipment.map((each, i) => (
                        <li key={i}>
                          <TableCell
                            data={each.label}
                            idField={`${idField}.applicationEquipment[${i}].label["@none"]`}
                          />
                        </li>
                      ))}
                    </ul>
                  </>
                )}

              {data.applicationContext && (
                <DetailRow
                  label="Application Context"
                  data={data.applicationContext}
                  idField={`${idField}.applicationContext["@none"]`}
                />
              )}

              {renderProtectionSection(
                "Hand Protection",
                data.handProtection,
                "handProtection"
              )}

              {renderProtectionSection(
                "Body Protection",
                data.bodyProtection,
                "bodyProtection"
              )}

              {renderProtectionSection(
                "Eye Protection",
                data.eyeProtection,
                "eyeProtection"
              )}

              {renderProtectionSection(
                "Respiratory Protection",
                data.respiratoryProtection,
                "respiratoryProtection"
              )}

              {renderProtectionSection(
                "Foot Protection",
                data.footProtection,
                "footProtection"
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PPEInstructionsStructured;